import * as type from "../types/campaigns";

const initialState = {
  channels: [],
  content: [],
  deletionArray: [],
  activeChannel: {
    username: null,
    timestamp: null,
    type: "email",
    active: null,
    credits: {
      data: {
        used: 0,
        total: 0,
      },
      loading: true,
      error: null,
    },
    reputation: {
      score: 0,
      loading: true,
      error: null,
    },
    statistics: {
      date: null,
      data: {
        delivered: 0,
        opened: 0,
        clicked: 0,
        deferred: 0,
        bounces: 0,
      },
      loading: true,
      error: null,
    },
    source: {
      status: undefined,
      error: null,
      loading: true,
    },
  },
  fetchAllChannels: {
    status: null,
    error: null,
    loading: true,
  },
  fetchAllEmails: {
    status: null,
    error: null,
    loading: true,
  },
  fetchAllSms: {
    status: null,
    error: null,
    loading: true,
  },
  addSmsChannel: {
    status: null,
    error: null,
    loading: false,
    username: null,
  },
  deleteEmailChannelDomain: {
    status: null,
    error: null,
    loading: false,
  },
  sendBulkEmails: {
    status: null,
    error: null,
    loading: false,
  },
  sendBulkSms: {
    status: null,
    error: null,
    loading: false,
  },
  fetchDistributionSelections: {
    data: {
      contactLists: [],
      templates: [],
    },
    status: null,
    error: null,
    loading: false,
  },
  addEmailChannel: {
    status: null,
    error: null,
    loading: false,
    details: null,
  },
  showModals: {
    newChannelModal: false,
    deleteChannelModal: false,
    deleteDomainModal: false,
    distributeModal: false,
    verifyDomainModal: false,
    completeSetupModal: false,
    viewEmailModal: false,
    purchaseNumberModal: false,
    deleteNumberModal: false,
    changeEmailReachModal: false,
    changeSmsReachModal: false,
  },
  initializeDomain: {
    authentication: {
      status: null,
      loading: false,
      error: null,
      details: null,
    },
    verification: {
      status: null,
      loading: false,
      error: null,
      details: null,
    },
  },
  emailDisplay: {
    content: null,
  },
  changeEmailPlan: {
    status: null,
    error: null,
    loading: false,
  },
  deleteEmailChannel: {
    status: null,
    error: null,
    loading: false,
  },
  fetchNumberOptions: {
    details: null,
    status: null,
    error: null,
    loading: false,
  },
  purchaseNumber: {
    status: null,
    error: null,
    loading: false,
  },
  deleteSmsChannelNumber: {
    status: null,
    error: null,
    loading: false,
  },
  changeSmsPlan: {
    status: null,
    error: null,
    loading: false,
  },
};

export const campaigns = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_CAMPAIGNS_CHANNELS:
      return {
        ...state,
        fetchAllChannels: {
          ...state.fetchAllChannels,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_CAMPAIGNS_CHANNELS:
      return {
        ...state,
        content: [],
        fetchAllChannels: {
          ...state.fetchAllChannels,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_CAMPAIGNS_CHANNELS:
      return {
        ...state,
        channels: payload.content,
        fetchAllChannels: {
          ...state.fetchAllChannels,
          error: null,
          loading: false,
        },
      };
    case type.RESET_CAMPAIGNS_CHANNELS:
      return {
        ...state,
        channels: [],
        fetchAllChannels: {
          ...state.fetchAllChannels,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_CHANNEL_EMAILS_CONTENT:
      return {
        ...state,
        fetchAllEmails: {
          ...state.fetchAllEmails,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_CHANNEL_EMAILS_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllEmails: {
          ...state.fetchAllEmails,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_CHANNEL_EMAILS_CONTENT:
      return {
        ...state,
        content: payload.content,
        fetchAllEmails: {
          ...state.fetchAllEmails,
          error: null,
          loading: false,
        },
      };
    case type.RESET_CHANNEL_EMAILS_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllEmails: {
          ...state.fetchAllEmails,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_CHANNEL_SMS_CONTENT:
      return {
        ...state,
        fetchAllSms: {
          ...state.fetchAllSms,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_CHANNEL_SMS_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllSms: {
          ...state.fetchAllSms,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_CHANNEL_SMS_CONTENT:
      return {
        ...state,
        content: payload.content,
        fetchAllSms: {
          ...state.fetchAllSms,
          error: null,
          loading: false,
        },
      };
    case type.RESET_CHANNEL_SMS_CONTENT:
      return {
        ...state,
        content: [],
        fetchAllSms: {
          ...state.fetchAllSms,
          error: null,
          loading: false,
        },
      };
    case type.CHANGE_CAMPAIGNS_MODALS:
      if (
        payload.modal.newChannelModal === true ||
        payload.modal.newChannelModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newChannelModal: payload.modal.newChannelModal,
          },
        };
      } else if (
        payload.modal.deleteChannelModal === true ||
        payload.modal.deleteChannelModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteChannelModal: payload.modal.deleteChannelModal,
          },
        };
      } else if (
        payload.modal.deleteDomainModal === true ||
        payload.modal.deleteDomainModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteDomainModal: payload.modal.deleteDomainModal,
          },
        };
      } else if (
        payload.modal.distributeModal === true ||
        payload.modal.distributeModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            distributeModal: payload.modal.distributeModal,
          },
        };
      } else if (
        payload.modal.verifyDomainModal === true ||
        payload.modal.verifyDomainModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            verifyDomainModal: payload.modal.verifyDomainModal,
          },
        };
      } else if (
        payload.modal.completeSetupModal === true ||
        payload.modal.completeSetupModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            completeSetupModal: payload.modal.completeSetupModal,
          },
        };
      } else if (
        payload.modal.viewEmailModal === true ||
        payload.modal.viewEmailModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            viewEmailModal: payload.modal.viewEmailModal,
          },
        };
      } else if (
        payload.modal.changeEmailReachModal === true ||
        payload.modal.changeEmailReachModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            changeEmailReachModal: payload.modal.changeEmailReachModal,
          },
        };
      } else if (
        payload.modal.purchaseNumberModal === true ||
        payload.modal.purchaseNumberModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            purchaseNumberModal: payload.modal.purchaseNumberModal,
          },
        };
      } else if (
        payload.modal.deleteNumberModal === true ||
        payload.modal.deleteNumberModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteNumberModal: payload.modal.deleteNumberModal,
          },
        };
      } else if (
        payload.modal.changeSmsReachModal === true ||
        payload.modal.changeSmsReachModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            changeSmsReachModal: payload.modal.changeSmsReachModal,
          },
        };
      } else {
        return state;
      }
    case type.APPEND_CAMPAIGNS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: [...state.deletionArray, payload.id],
      };
    case type.SUBTRACT_CAMPAIGNS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: state.deletionArray.filter(
          (existing) => existing !== payload.id
        ),
      };
    case type.REQUEST_SET_ACTIVE_CHANNEL_CREDITS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          credits: {
            ...state.activeChannel.credits,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_SET_ACTIVE_CHANNEL_CREDITS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          credits: {
            ...state.activeChannel.credits,
            data: payload.details,
            loading: false,
            error: null,
          },
        },
      };
    case type.REVOKE_SET_ACTIVE_CHANNEL_CREDITS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          credits: {
            ...state.activeChannel.credits,
            data: {
              used: 0,
              total: 0,
            },
            loading: false,
            error: payload.message,
          },
        },
      };
    case type.RESET_SET_ACTIVE_CHANNEL_CREDITS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          credits: {
            ...state.activeChannel.credits,
            data: {
              used: 0,
              total: 0,
            },
            loading: false,
            error: null,
          },
        },
      };
    case type.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            data: payload.details,
            loading: false,
            error: null,
          },
        },
      };
    case type.REVOKE_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            data: {
              delivered: 0,
              opened: 0,
              clicked: 0,
              deferred: 0,
              bounces: 0,
            },
            loading: false,
            error: payload.message,
          },
        },
      };
    case type.RESET_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            data: {
              delivered: 0,
              opened: 0,
              clicked: 0,
              deferred: 0,
              bounces: 0,
            },
            loading: false,
            error: null,
          },
        },
      };
    case type.SET_ACTIVE_CHANNEL_DISPLAY:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          username: payload.details.username,
          email: payload.details.email,
          type: payload.details.type,
          timestamp: payload.details.timestamp,
          active: payload.details.active,
          id: payload.details.id,
        },
      };
    case type.RESET_ACTIVE_CHANNEL_DISPLAY:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          username: null,
          email: null,
          type: null,
          timestamp: null,
          active: null,
          id: null,
        },
      };
    case type.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          reputation: {
            ...state.activeChannel.reputation,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          reputation: {
            ...state.activeChannel.reputation,
            score: payload.details,
            loading: false,
            error: null,
          },
        },
      };
    case type.REVOKE_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          reputation: {
            ...state.activeChannel.reputation,
            loading: false,
            error: payload.message,
          },
        },
      };
    case type.RESET_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          reputation: {
            ...state.activeChannel.reputation,
            loading: false,
            error: null,
          },
        },
      };
    case type.REQUEST_SET_ACTIVE_CHANNEL_SOURCE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          source: {
            ...state.activeChannel.source,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_SET_ACTIVE_CHANNEL_SOURCE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          source: {
            ...state.activeChannel.source,
            status: payload.details,
            error: null,
            loading: false,
          },
        },
      };
    case type.REVOKE_SET_ACTIVE_CHANNEL_SOURCE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          source: {
            ...state.activeChannel.source,
            status: undefined,
            loading: false,
            error: payload.message,
          },
        },
      };
    case type.RESET_SET_ACTIVE_CHANNEL_SOURCE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          source: {
            ...state.activeChannel.source,
            status: undefined,
            loading: false,
            error: null,
          },
        },
      };
    case type.SET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            date: payload.details,
          },
        },
      };
    case type.RESET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE:
      return {
        ...state,
        activeChannel: {
          ...state.activeChannel,
          statistics: {
            ...state.activeChannel.statistics,
            date: null,
          },
        },
      };
    case type.REQUEST_DELETE_EMAIL_CHANNEL_DOMAIN:
      return {
        ...state,
        deleteEmailChannelDomain: {
          ...state.deleteEmailChannelDomain,
          status: null,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_DELETE_EMAIL_CHANNEL_DOMAIN:
      return {
        ...state,
        deleteEmailChannelDomain: {
          ...state.deleteEmailChannelDomain,
          status: payload.details,
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_DELETE_EMAIL_CHANNEL_DOMAIN:
      return {
        ...state,
        deleteEmailChannelDomain: {
          ...state.deleteEmailChannelDomain,
          status: null,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_DELETE_EMAIL_CHANNEL_DOMAIN:
      return {
        ...state,
        deleteEmailChannelDomain: {
          ...state.deleteEmailChannelDomain,
          status: null,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_DISTRIBUTION_SELECTIONS:
      return {
        ...state,
        fetchDistributionSelections: {
          ...state.fetchDistributionSelections,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_DISTRIBUTION_SELECTIONS:
      return {
        ...state,
        fetchDistributionSelections: {
          ...state.fetchDistributionSelections,
          data: payload.details,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_DISTRIBUTION_SELECTIONS:
      return {
        ...state,
        fetchDistributionSelections: {
          ...state.fetchDistributionSelections,
          data: {
            ...state.fetchDistributionSelections.data,
            contactLists: [],
            templates: [],
          },
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DISTRIBUTION_SELECTIONS:
      return {
        ...state,
        fetchDistributionSelections: {
          ...state.fetchDistributionSelections,
          data: {
            ...state.fetchDistributionSelections.data,
            contactLists: [],
            templates: [],
          },
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DOMAIN_AUTHENTICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          authentication: {
            ...state.initializeDomain.authentication,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_DOMAIN_AUTHENTICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          authentication: {
            ...state.initializeDomain.authentication,
            status: "success",
            loading: false,
            error: null,
            details: payload.details,
          },
        },
        activeChannel: {
          ...state.activeChannel,
          source: {
            ...state.activeChannel.source,
            status: {
              ...state.activeChannel.source.status,
              code: "pending",
              dns: payload.details,
            },
          },
        },
      };
    case type.REVOKE_DOMAIN_AUTHENTICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          authentication: {
            ...state.initializeDomain.authentication,
            status: null,
            loading: false,
            error: payload.message,
            details: null,
          },
        },
      };
    case type.RESET_DOMAIN_AUTHENTICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          authentication: {
            ...state.initializeDomain.authentication,
            status: null,
            loading: false,
            error: null,
            details: null,
          },
        },
      };
    case type.REQUEST_DOMAIN_VERIFICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          verification: {
            ...state.initializeDomain.verification,
            loading: true,
            error: null,
          },
        },
      };
    case type.GRANT_DOMAIN_VERIFICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          verification: {
            ...state.initializeDomain.verification,
            status: "success",
            loading: false,
            error: null,
            details: payload.details,
          },
        },
      };
    case type.REVOKE_DOMAIN_VERIFICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          verification: {
            ...state.initializeDomain.verification,
            status: null,
            loading: false,
            error: payload.message,
            details: null,
          },
        },
      };
    case type.RESET_DOMAIN_VERIFICATION:
      return {
        ...state,
        initializeDomain: {
          ...state.initializeDomain,
          verification: {
            ...state.initializeDomain.verification,
            status: null,
            loading: false,
            error: null,
            details: null,
          },
        },
      };
    case type.REQUEST_SEND_BULK_EMAILS:
      return {
        ...state,
        sendBulkEmails: {
          ...state.sendBulkEmails,
          status: null,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_SEND_BULK_EMAILS:
      return {
        ...state,
        sendBulkEmails: {
          ...state.sendBulkEmails,
          status: "success",
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_SEND_BULK_EMAILS:
      return {
        ...state,
        sendBulkEmails: {
          ...state.sendBulkEmails,
          status: null,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_SEND_BULK_EMAILS:
      return {
        ...state,
        sendBulkEmails: {
          ...state.sendBulkEmails,
          status: null,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_SEND_BULK_SMS:
      return {
        ...state,
        sendBulkSms: {
          ...state.sendBulkSms,
          status: null,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_SEND_BULK_SMS:
      return {
        ...state,
        sendBulkSms: {
          ...state.sendBulkSms,
          status: "success",
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_SEND_BULK_SMS:
      return {
        ...state,
        sendBulkSms: {
          ...state.sendBulkSms,
          status: null,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_SEND_BULK_SMS:
      return {
        ...state,
        sendBulkSms: {
          ...state.sendBulkSms,
          status: null,
          error: null,
          loading: false,
        },
      };
    case type.SET_SENT_EMAIL_DISPLAY:
      return {
        ...state,
        emailDisplay: {
          ...state.emailDisplay,
          content: payload.details,
        },
      };
    case type.RESET_SENT_EMAIL_DISPLAY:
      return {
        ...state,
        emailDisplay: {
          ...state.emailDisplay,
          content: null,
        },
      };
    case type.REQUEST_MAIL_PLAN_CHANGE:
      return {
        ...state,
        changeEmailPlan: {
          ...state.changeEmailPlan,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_MAIL_PLAN_CHANGE:
      return {
        ...state,
        changeEmailPlan: {
          ...state.changeEmailPlan,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_MAIL_PLAN_CHANGE:
      return {
        ...state,
        changeEmailPlan: {
          ...state.changeEmailPlan,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_MAIL_PLAN_CHANGE:
      return {
        ...state,
        changeEmailPlan: {
          ...state.changeEmailPlan,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_EMAIL_CHANNEL:
      return {
        ...state,
        addEmailChannel: {
          ...state.addEmailChannel,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_EMAIL_CHANNEL:
      return {
        ...state,
        addEmailChannel: {
          ...state.addEmailChannel,
          status: "success",
          loading: false,
          error: null,
          details: payload.details,
        },
      };
    case type.REVOKE_ADD_EMAIL_CHANNEL:
      return {
        ...state,
        addEmailChannel: {
          ...state.addEmailChannel,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_EMAIL_CHANNEL:
      return {
        ...state,
        addEmailChannel: {
          ...state.addEmailChannel,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_SMS_CHANNEL:
      return {
        ...state,
        addSmsChannel: {
          ...state.addSmsChannel,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_SMS_CHANNEL:
      return {
        ...state,
        addSmsChannel: {
          ...state.addSmsChannel,
          status: "success",
          loading: false,
          error: null,
          details: payload.details,
        },
      };
    case type.REVOKE_ADD_SMS_CHANNEL:
      return {
        ...state,
        addSmsChannel: {
          ...state.addSmsChannel,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_SMS_CHANNEL:
      return {
        ...state,
        addSmsChannel: {
          ...state.addSmsChannel,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_EMAIL_CHANNEL:
      return {
        ...state,
        deleteEmailChannel: {
          ...state.deleteEmailChannel,
          status: null,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_DELETE_EMAIL_CHANNEL:
      return {
        ...state,
        deleteEmailChannel: {
          ...state.deleteEmailChannel,
          status: payload.details,
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_DELETE_EMAIL_CHANNEL:
      return {
        ...state,
        deleteEmailChannel: {
          ...state.deleteEmailChannel,
          status: null,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_DELETE_EMAIL_CHANNEL:
      return {
        ...state,
        deleteEmailChannel: {
          ...state.deleteEmailChannel,
          status: null,
          error: null,
          loading: false,
        },
      };
    /** */
    case type.REQUEST_NUMBERS_AVAILABLE:
      return {
        ...state,
        fetchNumberOptions: {
          ...state.fetchNumberOptions,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_NUMBERS_AVAILABLE:
      return {
        ...state,
        fetchNumberOptions: {
          ...state.fetchNumberOptions,
          details: payload.details,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_NUMBERS_AVAILABLE:
      return {
        ...state,
        fetchNumberOptions: {
          ...state.fetchNumberOptions,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_NUMBERS_AVAILABLE:
      return {
        ...state,
        fetchNumberOptions: {
          ...state.fetchNumberOptions,
          details: null,
          status: null,
          error: null,
          loading: false,
        },
      };
    /* */
    case type.REQUEST_PURCHASE_NUMBER:
      return {
        ...state,
        purchaseNumber: {
          ...state.purchaseNumber,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_PURCHASE_NUMBER:
      return {
        ...state,
        purchaseNumber: {
          ...state.purchaseNumber,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_PURCHASE_NUMBER:
      return {
        ...state,
        purchaseNumber: {
          ...state.purchaseNumber,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_PURCHASE_NUMBER:
      return {
        ...state,
        purchaseNumber: {
          ...state.purchaseNumber,
          details: null,
          status: null,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_DELETE_SMS_CHANNEL_NUMBER:
      return {
        ...state,
        deleteSmsChannelNumber: {
          ...state.deleteSmsChannelNumber,
          status: null,
          error: null,
          loading: true,
        },
      };
    case type.GRANT_DELETE_SMS_CHANNEL_NUMBER:
      return {
        ...state,
        deleteSmsChannelNumber: {
          ...state.deleteSmsChannelNumber,
          status: payload.details,
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_DELETE_SMS_CHANNEL_NUMBER:
      return {
        ...state,
        deleteSmsChannelNumber: {
          ...state.deleteSmsChannelNumber,
          status: null,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_DELETE_SMS_CHANNEL_NUMBER:
      return {
        ...state,
        deleteSmsChannelNumber: {
          ...state.deleteSmsChannelNumber,
          status: null,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_SMS_PLAN_CHANGE:
      return {
        ...state,
        changeSmsPlan: {
          ...state.changeSmsPlan,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_SMS_PLAN_CHANGE:
      return {
        ...state,
        changeSmsPlan: {
          ...state.changeSmsPlan,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SMS_PLAN_CHANGE:
      return {
        ...state,
        changeSmsPlan: {
          ...state.changeSmsPlan,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SMS_PLAN_CHANGE:
      return {
        ...state,
        changeSmsPlan: {
          ...state.changeSmsPlan,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
